import comp from "./AssessmentToolPreviewModal";
export default comp;
